export default __webpack_public_path__ + "static/media/hand_holding_dirt.ddcb46ba.png";